






import Component from 'vue-class-component';
import { MeterFormModel } from '@/context/meter/model/form/MeterFormModel';
import { FormContainer } from '@/common/mixin/FormContainer';
import MeterCreateForm from '@/context/meter/component/form/MeterCreateForm.vue';
import { meterApi } from '@/context/meter/api/MeterApi';

@Component({
  components: {
    MeterCreateForm
  }
})
export default class CreateMeterContainer extends FormContainer<MeterFormModel> {
  model: MeterFormModel = new MeterFormModel();

  async formApi(): Promise<MeterFormModel> {
    const response: MeterFormModel = await meterApi.form<MeterFormModel>(MeterFormModel, null);
    return response;
  }
}
